import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 文件下载输入报文
 */
export type FabricHttpFileDownloadOptions = {
  /**
   * 下载资源的 url
   */
  url: string;
  /**
   * 指定文件下载后存储的路径
   */
  filePath?: string;
  /**
   * HTTP 请求的 Header，Header 中不能设置 Referer
   */
  headers?: Record<string, string>;
  /**
   * 超时时间，单位为毫秒
   */
  timeout?: number;
};

/**
 * 文件下载输入报文
 */
export type FabricHttpFileDownloadCallbackData = {
  /**
   * 用户文件路径 (本地路径)。传入 filePath 时会返回，跟传入的 filePath 一致
   */
  filePath: string;
  /**
   * 临时文件路径 (本地路径)。没传入 filePath 指定文件存储路径时会返回，下载后的文件会存储到一个临时文件
   */
  tempFilePath: string;
  /**
   * 开发者服务器返回的 HTTP 状态码
   */
  statusCode: number;
  /**
   * 上传进度0-1, 1:标识当前文件下载完成,
   * 此处一定会等于1, 并且==1的时候Native执行callback complete清理内存
   */
  progress: number;
};

export type FabricHttpDownloadApi = (
  options: FabricHttpFileDownloadOptions
) => Promise<FabricHttpFileDownloadCallbackData>;

export const downloadFile: FabricHttpDownloadApi = (
  options: FabricHttpFileDownloadOptions
) => {
  return new Promise<FabricHttpFileDownloadCallbackData>((resolve, reject) => {
    core.call<
      'fabric_http.downloadFile',
      FabricHttpFileDownloadOptions,
      FabricHttpFileDownloadCallbackData
    >('fabric_http.downloadFile', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
